import { Button } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledGoBackButton = styled(Button)`
  display: flex;
  align-items: center;
  margin: 2px 0;
  color: #fff !important;

  .anticon {
    font-size: 18px;
  }
`;

export const StyledLink = styled(Link)`
  width: fit-content;
  text-decoration: none;
`;
